import RequiredReactSelect from "@components/FormsV2/RequiredReactSelect/RequiredReactSelect";
import type { PrivilegeDefinition } from "../types";

interface OptionType {
  value: string;
  label: string;
}

const titleize = (s: string): string =>
  s
    .split("_")
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(" ");

export interface PrivilegeSelectProps {
  definition: PrivilegeDefinition;
  value: string;
  onChange: (value: string) => void;
}

export const PrivilegeSelect = ({
  definition,
  value,
  onChange,
}: PrivilegeSelectProps): JSX.Element => {
  const options: OptionType[] = [
    { value: "", label: "— Select —" },
    ...definition.levels.map((level) => ({
      value: level,
      label: titleize(level),
    })),
  ];
  const selected = options.find((o) => o.value === value);

  return (
    <div className="mb-3">
      <RequiredReactSelect
        label={definition.name}
        value={selected}
        options={options}
        placeholder="— Select —"
        onChange={(opt) => {
          const o = opt as OptionType | null;
          onChange(o?.value ?? "");
        }}
      />
      {definition.description && (
        <div className="small text-muted">{definition.description}</div>
      )}
    </div>
  );
};

export default PrivilegeSelect;
